import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import PresenceActiveIcon from "@atlaskit/icon/glyph/presence-active";
import { media } from "@atlaskit/primitives/responsive";

import Link from "@/components/wpl/link/src";

import { tabbedHeroSectionPagesMessages } from "../messages/tabbed-hero-section.messages";

import { ContentTypeVideo } from "./content-type-video";

const hideMobile = css({
    [media.below.md]: {
        display: "none"
    }
});

export const PagesContentType = () => {
    const intl = useIntl();

    return (
        <ContentTypeVideo
            title={intl.formatMessage(
                tabbedHeroSectionPagesMessages.contentTitle
            )}
            description={intl.formatMessage(
                tabbedHeroSectionPagesMessages.contentDescription
            )}
            iconTitle={intl.formatMessage(
                tabbedHeroSectionPagesMessages.contentIconTitle
            )}
            iconCollection={[
                {
                    description: intl.formatMessage(
                        tabbedHeroSectionPagesMessages.contentFeaturePoint1
                    ),
                    icon: <PresenceActiveIcon size="small" label="" />
                },
                {
                    description: intl.formatMessage(
                        tabbedHeroSectionPagesMessages.contentFeaturePoint2
                    ),
                    icon: <PresenceActiveIcon size="small" label="" />
                },
                {
                    description: intl.formatMessage(
                        tabbedHeroSectionPagesMessages.contentFeaturePoint3
                    ),
                    icon: <PresenceActiveIcon size="small" label="" />
                }
            ]}
            cta={
                intl.locale === "en" ? (
                    <div css={hideMobile}>
                        <Link
                            href={
                                "https://www.atlassian.com/confluence-sandbox-editor"
                            }
                            text={intl.formatMessage(
                                tabbedHeroSectionPagesMessages.contentCta
                            )}
                            type={"basic"}
                            doesArrowAnimate={true}
                            dataEventProps={{
                                "data-product-key": "confluence",
                                "data-event-component": "linkButton",
                                "data-event-container": "contentTypesSection",
                                "data-event": "clicked",
                                "data-label": "try-it-out",
                                "data-label-english": "Try it out",
                                "data-track-event":
                                    "confluence-pt.content-types.pages.cta"
                            }}
                        />
                    </div>
                ) : undefined
            }
            reverseLayout
            videoSrc="https://wac-cdn.atlassian.com/misc-assets/videos/confluence-product-tour/PT_CT_Pages_LowBR.webm"
            videoPreviewSrc="https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/PT_CT_Pages_Preview.webp"
        />
    );
};
